import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ResetPasswordResponseViewModel, RolesModel } from 'common/models/UserTypes';
import { OperationStatus } from 'store/rootTypes';

const name = 'Account';

interface IAccountState {
  submitStatus: OperationStatus;
  RoleName?: string;
  WorkLocationCountry?: string;
  Roles?: RolesModel[];
  IsConfirm: boolean;
  ResetPasswordLink?: string;
  Username?: string;
  WorkLocationStateCode?: string;
  IsValidEmailResetPassword: boolean;
  ResetPasswordEmail?: string;
  ResetPasswordResponseViewModel?: ResetPasswordResponseViewModel;
  IsValidOTP: boolean;
  SenderHaveExistingTransactionsMobile: boolean;
}

const initialState: IAccountState = {
  submitStatus: OperationStatus.idle,
  RoleName: undefined,
  Roles: undefined,
  IsConfirm: true,
  IsValidEmailResetPassword: true,
  IsValidOTP: true,
  SenderHaveExistingTransactionsMobile: false,
};

export const AccountSlice = createSlice({
  name,
  initialState,
  reducers: {
    resetState: () => {
      return initialState;
    },
    SetRoleName: (state, action: PayloadAction<string>) => {
      state.RoleName = action.payload;
    },
    SetUserName: (state, action: PayloadAction<string>) => {
      state.Username = action.payload;
    },
    SetSenderHaveExistingTransactionsMobile: (state, action: PayloadAction<boolean>) => {
      state.SenderHaveExistingTransactionsMobile = action.payload;
    },
    SetWorkLocationCountry: (state, action: PayloadAction<string>) => {
      state.WorkLocationCountry = action.payload;
    },
    SetWorkLocationStateCode: (state, action: PayloadAction<string>) => {
      state.WorkLocationStateCode = action.payload;
    },
    SetIsConfirm: (state, action: PayloadAction<boolean>) => {
      state.IsConfirm = action.payload;
    },
    SetRoles: (state, action: PayloadAction<RolesModel[]>) => {
      state.Roles = action.payload;
    },
    SetIsValidOTP: (state, action: PayloadAction<boolean>) => {
      state.IsValidOTP = action.payload;
    },
    SetResetPasswordLink: (state, action: PayloadAction<string>) => {
      state.ResetPasswordLink = action.payload;
    },
    SetIsValidEmailResetPassword: (state, action: PayloadAction<boolean>) => {
      state.IsValidEmailResetPassword = action.payload;
    },
    SetResetPasswordEmail: (state, action: PayloadAction<string>) => {
      state.ResetPasswordEmail = action.payload;
    },
    SetResetPasswordResponseViewModel: (state, action: PayloadAction<ResetPasswordResponseViewModel>) => {
      state.ResetPasswordResponseViewModel = action.payload;
    },
    submitStatus: (state) => handlePendingSubmitAction(state),
    submitStatusRejected: (state, action: PayloadAction<string>) => handleSubmitRejection(state, action),
    submitStatusSucceeded: (state) => {
      state.submitStatus = OperationStatus.succeeded;
    },
    resetSubmitStatus: (state) => {
      state.submitStatus = OperationStatus.idle;
    },
  },
});

const handlePendingSubmitAction = (state) => {
  state.submitStatus = OperationStatus.pending;
};

const handleSubmitRejection = (state, action: PayloadAction<string>) => {
  state.submitStatus = OperationStatus.failed;
  console.error(action.payload);
};

export const { actions: AccountActions } = AccountSlice;

export default AccountSlice.reducer;
